import { Dispatch, SetStateAction, useContext, useMemo } from "react";
import { Box } from "@mui/material";
import { Schema } from "src/modules/flow-designer/vts/select-tables-modal/schema-table";
import { SelectTablesWrapper } from "src/modules/flow-designer/vts/select-tables-modal/components";
import {
    WhatIsTable,
    TableWrapper
} from "app/components/appwizard/component-wizards/wizards/source/database-reader/configs/db-providers.utils";
import { DB_PROVIDERS } from "app/components/appwizard/component-wizards/wizards/source/database-reader/configs/db-providers";
// @ts-ignore
import getTableNameWithCorrectDots from "app/components/appwizard/component-wizards/wizards/source/database-reader/table-name-validator";
import api from "core/api/api";
import { wizardcontext } from "../../../source-configurator-tool";
import { getEntityTypeFromDBType, getSchemaTypeFromDBType } from "src/modules/flow-designer/vts/selectTables-utils";
import { StepProps } from "../../source-configurator.types";
import SidebarStepFooter from "../../sidebar-step-footer";

const convertToBackboneModel = (obj: any) => ({ get: (key: string) => obj?.[key] });

const SelectTablesWrapperPage = ({ onNext, onBack, onCancel }: StepProps) => {
    const { selectedSchemas, setState, sourceType, mode, connectionParams } = useContext(wizardcontext);

    const handleSetSchemas: Dispatch<SetStateAction<Schema[]>> = schemasOrUpdater => {
        setState((prev: any) => ({
            ...prev,
            selectedSchemas:
                typeof schemasOrUpdater === "function" ? schemasOrUpdater(prev.selectedSchemas) : schemasOrUpdater
        }));
    };

    const hasSelectedTables = useMemo(() => selectedSchemas.some((s: Schema) => s.tables?.some(t => t.isSelected)), [
        selectedSchemas
    ]);

    const entityType = getEntityTypeFromDBType(sourceType ?? "");
    const schemaType = getSchemaTypeFromDBType(sourceType ?? "");
    const isCDC = mode === "Change Data Capture";

    const handleNext = async () => {
        connectionParams.type = sourceType;
        const connectionParamsModel = convertToBackboneModel(connectionParams);

        const selectedTables = selectedSchemas
            .flatMap((schema: Schema) => schema.tables ?? [])
            .filter(table => table.isSelected)
            .map(table => getTableNameWithCorrectDots(table.fullTableName, connectionParamsModel, isCDC));

        const isMongoLikeDatabase = [
            DB_PROVIDERS.MONGODB.id,
            DB_PROVIDERS.COSMOSDB.id,
            DB_PROVIDERS.MONGO_COSMOSDB.id
        ].includes(sourceType ?? "");
        const escapedSelectedTables: string[] = isMongoLikeDatabase
            ? selectedTables
            : (((await api.getEscapedNames(selectedTables)) as unknown) as string[]);

        setState((prev: any) => ({ ...prev, escapedSelectedTables }));
        // Pass the computed list directly so the caller gets fresh data
        // without waiting for the async state flush.
        (onNext as (tables?: string[]) => void)(escapedSelectedTables);
    };

    return (
        <Box sx={{ width: "100%" }}>
            <SelectTablesWrapper
                compact
                schemas={selectedSchemas}
                setSchemas={handleSetSchemas}
                sourceInfo={{
                    entityType: entityType as WhatIsTable,
                    isAppAdapter: false,
                    schemaType: schemaType as TableWrapper,
                    dbType: sourceType ?? "",
                    isCDC
                }}
            />
            <SidebarStepFooter
                onCancel={onCancel}
                onBack={onBack}
                onNext={handleNext}
                nextDisabled={!hasSelectedTables}
            />
        </Box>
    );
};

export default SelectTablesWrapperPage;
